module.exports = __webpack_public_path__ + "img/Berget-2026.33a0a311.jpg";